import { sanitizeAssets } from './sanitize-assets'
import { InstallationPriceSimulationRequest } from '@modules/installation-price-simulation/infrastructure/installation-price-simulation-request.types'

// state.specs en offerOnVisit lo construye OfferSpecs(...) (src/domain/OfferSpecs).
// Tipo permisivo a propósito: el dominio no está tipado en TS y los valores pueden
// llegar como string si vienen de un input no convertido.
type OfferSpecsLike = {
  tension?: string
  installationType?: string | number
  panels1?: number | string
  panels2?: number | string
  shadedPanels1?: number | string
  shadedPanels2?: number | string
  tilt1?: number | string
  panelsModel?: string
  extraAdditionalCost?: number | string
  energyEfficiencyCertificateQuantity?: number
  assets?: Record<string, { id: string; amount: number | string }> | unknown[]
  discounts?: Record<string, number | string>
  cups?: string
}

export function buildInstallationPricePayloadFromOffer(
  specs: OfferSpecsLike
): InstallationPriceSimulationRequest {
  const installationType = String(specs.installationType ?? '')
  const tensionVoltage = String(specs.tension ?? '')
  const d = specs.discounts ?? {}

  return {
    tension: `${installationType}x${tensionVoltage}`,
    // El nº de placas a tarificar es el TOTAL: óptimas + en sombra. Las placas en
    // sombra son placas físicas instaladas (cuestan lo mismo), no un subconjunto de
    // panels1. Hay que sumarlas igual que getUpsertOfferSpecsParams (simulate-verified):
    // si solo mandáramos panels1+panels2, el back tarificaría de menos y la línea de
    // placas bajaría al recalcular descuentos.
    panels:
      (Number(specs.panels1) || 0) +
      (Number(specs.shadedPanels1) || 0) +
      (Number(specs.panels2) || 0) +
      (Number(specs.shadedPanels2) || 0),
    panelsModel: String(specs.panelsModel ?? 'silver'),
    assets: sanitizeAssets(specs.assets as never),
    extraAdditionalCost: Number(specs.extraAdditionalCost) || 0,
    energyEfficiencyCertificateQuantity:
      Number(specs.energyEfficiencyCertificateQuantity) || 0,
    discounts: {
      installation: 0,
      panels: Number(d.panels) || 0,
      battery: Number(d.battery) || 0,
      evCharger: Number(d.evCharger) || 0,
      certificate: Number(d.certificate) || 0,
    },
    cups: specs.cups,
    tilt1: Number(specs.tilt1) || 0,
    // roofType, clientType, energyReform y postalCode quedan fuera a propósito:
    // el BE los rellena vía OfferFinder($cups) o deriva roofType desde tilt1.
  }
}
